import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';

import CrearTraspaso from './traspasos/CrearTraspaso';
import VerTraspasos from './traspasos/VerTraspasos';
import ConfirmarTraspaso from './traspasos/ConfirmarTraspaso';
import EditarTraspaso from './traspasos/EditarTraspaso';
import VisualizarTraspaso from './traspasos/VisualizarTraspaso';
import TraspasosPorOrganismo from './reportes/TraspasosPorOrganismo';
import PrecargarTraspaso from './traspasos/PrecargarTraspaso';

import VerCertificacionesTraspaso from './certificaciones/VerCertificacionesTraspaso';
import VisarCertificacionTraspaso from './certificaciones/VisarCertificacionTraspaso';
import ProcesarCertificacionTraspaso from './certificaciones/ProcesarCertificacionTraspaso';
import EditarCertificacionTraspaso from './certificaciones/EditarCertificacionTraspaso';
import OtraCertificacionesTraspasoContainer from './certificaciones/OtraCertificacionesTraspasoContainer';

import CrearLicencia from './licencias/CrearLicencia';
import VerLicencias from './licencias/VerLicencias';
import EvaluarLicencia from './licencias/EvaluarLicencia';
import EditarLicencia from './licencias/EditarLicencia';
import LicenciasPorOrganismo from './reportes/LicenciasPorOrganismo';

import CargarNovedad from './novedades/CargarNovedad';
import VerNovedades from './novedades/VerNovedades';

import * as Roles from '../common/DeclaracionRoles';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspasos/crear`}
              component={CrearTraspaso}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspaso/:id/ver`}
              component={VisualizarTraspaso}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspaso/:id/precargar`}
              component={PrecargarTraspaso}
              rolesAutorizados={[
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspaso/:id/confirmar`}
              component={ConfirmarTraspaso}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspaso/:id`}
              component={EditarTraspaso}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/traspasos`}
              component={VerTraspasos}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificacionesTraspaso`}
              component={VerCertificacionesTraspaso}
              rolesAutorizados={[
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
                Roles.SUELDOS,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/otrasCertificacionesTraspaso`}
              component={OtraCertificacionesTraspasoContainer}
              rolesAutorizados={[
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
                Roles.SUELDOS,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificacionTraspaso/:id/visar`}
              component={VisarCertificacionTraspaso}
              rolesAutorizados={[Roles.DGJP_DIRECTOR, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificacionTraspaso/:id/editar`}
              component={EditarCertificacionTraspaso}
              rolesAutorizados={[
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/certificacionTraspaso/:id/procesar`}
              component={ProcesarCertificacionTraspaso}
              rolesAutorizados={[Roles.SUELDOS, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/licencias/crear`}
              component={CrearLicencia}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/licencias`}
              component={VerLicencias}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/licencias/:id/evaluar`}
              component={EvaluarLicencia}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/licencias/:id`}
              component={EditarLicencia}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/novedades/crear`}
              component={CargarNovedad}
              rolesAutorizados={[
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.ADMINISTRADOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/novedades`}
              component={VerNovedades}
              rolesAutorizados={[
                Roles.SUELDOS,
                Roles.GESTION_HUMANA,
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reportes/traspasos`}
              component={TraspasosPorOrganismo}
              rolesAutorizados={[
                Roles.GESTION_HUMANA,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reportes/licencias`}
              component={LicenciasPorOrganismo}
              rolesAutorizados={[
                Roles.GESTION_HUMANA,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.DGJP_EMPLEADO,
              ]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
